import React from 'react';
import moment from 'moment';
moment.locale("en");
type Props = {
  title: string;
  value: number | string;
};

const InventoryInfoBox: React.FC<Props> = ({ title, value }) => {
  return (
    <div className="card border-0 text-center p-2" style={{ maxWidth: '460px', height: '115px', }}    >
      <div>
        <h6 className="fw-bold mb-1">{title}  ({moment().add(-1,"month").format('MMMM YYYY')})</h6>
        <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{value}</div>
      </div>
    </div>
  );
};

export default InventoryInfoBox;
